var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, DotsLoader } from "@brushfire/ui";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
var AuthResult = function (_a) {
    var theme = _a.theme, isWidget = _a.isWidget;
    var _b = __read(useState(false), 2), showButton = _b[0], setShowButton = _b[1];
    var location = useLocation();
    var queryParams = new URLSearchParams(location.search);
    var sendMessage = function () {
        var port = window.parent.location.port === "4000" ? ":4000" : "";
        window.parent.postMessage(queryParams.get("status"), "https://".concat(window.parent.location.hostname).concat(port));
    };
    var tryAgain = function () {
        setShowButton(false);
        sendMessage();
        setTimeout(function () {
            setShowButton(true);
        }, 60000);
    };
    useEffect(function () {
        tryAgain();
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx(Helmet, { children: _jsx("body", { className: "auth-result-page" }) }), _jsxs("div", __assign({ className: "absolute-center" }, { children: [_jsx("div", __assign({ className: "auth-result-dots" }, { children: _jsx(DotsLoader, {}) })), _jsx("div", __assign({ className: "m-top-medium" }, { children: "Please wait while we attempt to process your payment..." })), showButton && (_jsx(Button, __assign({ purpose: "primary", classes: "m-top-medium", onClick: sendMessage }, { children: "Try Again" })))] }))] }));
};
export default AuthResult;
